import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import $crypto from '@/utils/crypto'
import utils from '@/utils/utils'
import { setTitle, beforeloadNotCheckBycode, fetchLocalStorageData } from '@/utils/window'

// 不能按需加载
import PageNotline from '@/pages/error/pageNotline.vue'
import ServerError from '@/pages/error/serverError.vue'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      // 正常打开（只能有这个界面带有edit）
      path: '/webOnlineEdit/edit/:docId/:userId',
      name: 'WpsEditFile',
      component: () => import('@/pages/wpsEditFile.vue')
    },
    // {
    //   // 打开wps之后断网----370版本干掉，需要都跳转到ServerError的页面中
    //   path: '/webOnlineEdit/page/notline/:docId/:userId',
    //   name: 'PageNotline',
    //   component: PageNotline
    // },
    {
      // 暂时系统的错误页面都会跳转到这里
      path: '/webOnlineEdit/server/error/:docId/:userId',
      name: 'ServerError',
      component: ServerError
    },
    {
      // 数据错误（无需返回编辑页）
      path: '/webOnlineEdit/page/error/:message(.*)*',
      name: 'PageError',
      component: () => import('@/pages/error/pageError.vue')
    },
    {
      // 重复打开（暂时用不到）
      path: '/webOnlineEdit/page/repetition',
      name: 'PageRepetition',
      component: () => import('@/pages/error/pageRepetition.vue')
    },
    {
      // 浏览器版本过低（无需返回编辑页）
      path: '/webOnlineEdit/page/broswerLow',
      name: 'BroswerLow',
      component: () => import('@/pages/error/broswerLow.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  console.log(window.location.href)
  // 路由变化需要清除 wps 的DOM节点，不然层级太高了
  const _toPathArray = to.path.split('/')

  // 判断路由是否带有 edit（此路由是唯一的）
  const toPathHasEdit =
    (_toPathArray && _toPathArray.findIndex(e => e === 'edit') !== -1) || false
  const toDocId = _toPathArray && _toPathArray[_toPathArray.length - 2]
  const toUserId = _toPathArray && _toPathArray[_toPathArray.length - 1]
  
  if (to.path === '/' || to.path === '/ibsaas-wps-online-edit/index.html') {
    const match = window.location.href.match(/query=(\S*)/)
    if (match) {
      const queryParams = match[1]
      const deParams = JSON.parse($crypto.decode(queryParams))
      store.dispatch('storageRouteData', deParams)
      // 设置 storage
      beforeloadNotCheckBycode(deParams)
      setTitle(store.getters.docName)
      utils.windowToAllSelfPage(`webOnlineEdit/edit/${deParams.docId}/${deParams.userId}`)
    } else {
      utils.windowToAllSelfPage(`webOnlineEdit/page/error`)
    }
  } else if (toPathHasEdit) {
    // 处理刷新和首次进入的情况，都从存储获取数据
    const _jsonItemName = fetchLocalStorageData()
    const deParams = []
    _jsonItemName.forEach(e => {
      if (e.docId == parseInt(toDocId) && e.userId === parseInt(toUserId)) {
        deParams.push(e)
      }
    })
    if (!deParams.length) {
      utils.windowToAllSelfPage(`webOnlineEdit/page/error`)
      return
    }
    store.dispatch('storageRouteData', deParams[0])
    setTitle(store.getters.docName)
    next()
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js